/**
 * 異動單數量 guard：≥0、scrap+cancel≤製造量、應入庫量≥已入庫量。
 */

export function computeExpectedReceiptQty(manufacturingQty, scrapQty, cancelQty) {
  const manufacturing = Number(manufacturingQty);
  const scrap = Number(scrapQty);
  const cancel = Number(cancelQty);
  if ([manufacturing, scrap, cancel].some((value) => Number.isNaN(value))) {
    return null;
  }
  return manufacturing - scrap - cancel;
}

export function getAmendmentQtyGuardErrors({
  scrapQty,
  cancelQty,
  manufacturingQty,
  completedQty,
}) {
  const scrap = Number(scrapQty);
  const cancel = Number(cancelQty);
  const manufacturing = Number(manufacturingQty);
  const completed = Number(completedQty ?? 0);
  const errors = [];

  if (Number.isNaN(scrap) || scrap < 0) {
    errors.push({ path: 'scrapQty', message: '數量須為 ≥ 0 的數字' });
  }
  if (Number.isNaN(cancel) || cancel < 0) {
    errors.push({ path: 'cancelQty', message: '數量須為 ≥ 0 的數字' });
  }
  if (errors.length > 0 || Number.isNaN(manufacturing)) {
    return errors;
  }

  if (scrap + cancel > manufacturing) {
    errors.push({
      path: 'cancelQty',
      message: '報廢量加取消量不得大於製造量',
    });
  }

  const expectedReceipt = computeExpectedReceiptQty(
    manufacturing,
    scrap,
    cancel,
  );
  if (expectedReceipt != null && !Number.isNaN(completed) && expectedReceipt < completed) {
    errors.push({
      path: 'scrapQty',
      message: '調整後應入庫量不得低於已入庫量',
    });
  }

  return errors;
}
